import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export const AGE_CONFIRMATION_KEY = "un_age_18_confirmed_v1";
const SAFETY_ROUTES = new Set(["/safereach", "/reset", "/practices", "/toolkit", "/zen", "/safe-mode"]);

function previouslyConfirmed() {
  try { return localStorage.getItem(AGE_CONFIRMATION_KEY) === "1"; }
  catch { return false; }
}

export default function AgeConfirmation({ children }) {
  const { pathname } = useLocation();
  const [confirmed, setConfirmed] = useState(previouslyConfirmed);
  const [under18, setUnder18] = useState(false);
  const path = pathname.replace(/\/+$/, "") || "/";
  if (confirmed || SAFETY_ROUTES.has(path)) return children;

  const confirm = () => {
    try { localStorage.setItem(AGE_CONFIRMATION_KEY, "1"); } catch {}
    setConfirmed(true);
  };

  return (
    <main className="min-h-screen un-safe-top px-5 py-8 flex items-center justify-center">
      <section className="w-full max-w-[520px] rounded-3xl p-6" style={{ background: "var(--un-bg-2)", color: "var(--un-text-1)" }} aria-labelledby="age-confirmation-title">
        <h1 id="age-confirmation-title" className="text-[30px] leading-tight" style={{ fontFamily: "Lora, serif", color: "var(--un-plum-deep)" }}>Before you begin</h1>
        <p className="mt-4 leading-relaxed">You must be 18 or older to continue into the private app.</p>
        <p className="mt-2 leading-relaxed">Please confirm your age to continue. Your confirmation stays on this device; we do not ask for your date of birth.</p>
        <div className="grid gap-3 mt-6">
          <button type="button" onClick={confirm} className="min-h-12 px-4 py-3 rounded-2xl" style={{ background: "var(--un-plum)", color: "#fffaf5" }}>I am 18 or older</button>
          <button type="button" onClick={() => setUnder18(true)} className="min-h-12 px-4 py-3 rounded-2xl" style={{ border: "1px solid var(--un-plum)", color: "var(--un-plum)" }}>I am under 18</button>
        </div>
        {under18 && <p role="status" className="mt-4 leading-relaxed">You can still use safety resources and free reset techniques below.</p>}
        <div className="flex flex-wrap gap-x-5 gap-y-3 mt-6">
          <Link to="/safereach" className="underline underline-offset-4">Safe Reach</Link>
          <Link to="/reset" className="underline underline-offset-4">Free reset techniques</Link>
        </div>
        <div className="flex flex-wrap gap-5 mt-5">
          <Link to="/terms" className="underline underline-offset-4">Terms</Link>
          <Link to="/privacy" className="underline underline-offset-4">Privacy</Link>
        </div>
      </section>
    </main>
  );
}
